import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LatLng } from 'leaflet';
import { siteBeginIcon, siteEndIcon } from '../../../../projects/qpoint-maps/src/lib/components/map/default-map-icons';
import { MapPolygonComponent, QPointMapPolygon } from '../../../../projects/qpoint-maps/src/lib/components/map/map-polygon/map-polygon.component';

import { MapMarkerComponent, MapPolylineComponent, QPointMapPolyline } from '../../../../projects/qpoint-maps/src/public_api';
import { MapComponent } from "../../../../projects/qpoint-maps/src/lib/components/map/map.component";

@Component({
    selector: 'app-map-sba-project-test',
    imports: [
        CommonModule,
        MapComponent,
        MapMarkerComponent,
        MapPolygonComponent,
        MapPolylineComponent
    ],
    templateUrl: './map-sba-project-test.component.html',
    styleUrls: ['./map-sba-project-test.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapSbaProjectTestComponent {
  zoomPosition: google.maps.ControlPosition = google.maps.ControlPosition.RIGHT_TOP;
  center = new LatLng(46.69407594, 16.11388167);

  mapMarkerOptions = [
    { position: new LatLng(46.69407594, 16.11388167), icon: siteBeginIcon() },
    { position: new LatLng(46.69407594, 16.11398167), icon: siteEndIcon() }
  ];

  siteArea: QPointMapPolygon = {
        type: 'Polygon',
        coordinates: [[
          [
            16.11378167,
            46.69407594
          ],
          [
            16.11426662,
            46.69420077
          ],
          [
            16.11446662,
            46.69385111
          ],
          [
            16.11385168,
            46.69362628
          ],
          [
            16.11378167,
            46.69407594
          ]
        ]]
    };

  pavingPath: QPointMapPolyline = {
      type: 'LineString',
      coordinates: [
        [
          16.11388167,
          46.69407594
        ],
        [
          16.11398167,
          46.69407594
        ]
      ]
  };
}
